<template>
  <svg
    t="1658460641531"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="3017"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="200"
    height="200"
  >
    <path
      d="M512 0c-282.784 0-512 229.216-512 512s229.216 512 512 512l0-384-128 0 0-128 128 0 0-96c0-88.352 71.648-160 160-160l160 0 0 128-160 0c-17.664 0-32 14.336-32 32l0 96 176 0-32 128-144 0 0 367.872c220.832-56.832 384-257.312 384-495.872 0-282.784-229.216-512-512-512z"
      p-id="3018"
      fill="#1296DB"
    ></path>
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Facebook'
});
</script>
